import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'Station',
    column_type: 'id',
  },
  created_at: {
    model_name: 'Station',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'Station',
    column_type: 'datetime',
  },
  eurostar_uic: {
    model_name: 'Station',
    column_type: 'string',
  },
  position: {
    model_name: 'Station',
    column_type: 'integer',
  },
  eurostar_active: {
    model_name: 'Station',
    column_type: 'boolean',
  },
  popular: {
    model_name: 'Station',
    column_type: 'boolean',
  },
  name: {
    model_name: 'Station',
    column_type: 'string',
  },
  short_code: {
    model_name: 'Station',
    column_type: 'string',
  },
  prompt: {
    model_name: 'Station',
    column_type: 'string',
  },
  std_ticket_tips: {
    model_name: 'Station',
    column_type: 'string',
  },
  sp_ticket_tips: {
    model_name: 'Station',
    column_type: 'string',
  },
  bp_ticket_tips: {
    model_name: 'Station',
    column_type: 'string',
  },
  non_flexible_desc: {
    model_name: 'Station',
    column_type: 'text',
  },
  semi_flexible_desc: {
    model_name: 'Station',
    column_type: 'text',
  },
  fully_flexible_desc: {
    model_name: 'Station',
    column_type: 'text',
  },
  fake_leg: {
    model_name: 'Station',
    column_type: 'string',
  },
  country: {
    model_name: 'Station',
    column_type: 'string',
  },
  name_zh_cn: {
    model_name: 'Station',
    column_type: 'string',
  },
  standard_services: {
    model_name: 'Station',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  standard_premier_services: {
    model_name: 'Station',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  business_premier_services: {
    model_name: 'Station',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  nov_standard_services: {
    model_name: 'Station',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  nov_standard_premier_services: {
    model_name: 'Station',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  nov_business_premier_services: {
    model_name: 'Station',
    column_type: 'attached',
    extra: {
      size: 5,
    },
  },
  local_sceneries: {
    model_name: 'Station',
    column_type: 'has_many',
    extra: {
      association_name: 'local_sceneries',
      model_name: 'LocalScenery',
      foreign_key: 'local_scenery_id',
    },
  },
  local_scenery_ids: {
    model_name: 'Station',
    column_type: 'has_many',
    extra: {
      association_name: 'local_sceneries',
      model_name: 'LocalScenery',
      foreign_key: 'local_scenery_id',
    },
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
